export declare const ToFloat: any;
export default ToFloat;
export * from './src/float';
